import { type Observable, of } from 'rxjs';

import { type TranslateLoader, type TranslationObject } from '@ngx-translate/core';

import * as en from '@core/i18n/en';
import * as es from '@core/i18n/es';

const TRANSLATIONS: Record<string, TranslationObject> = {
  en: en as TranslationObject,
  es: es as TranslationObject,
};

const DEFAULT_LANG = 'en';

export class LocalTranslationLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<TranslationObject> {
    return of(TRANSLATIONS[lang] ?? TRANSLATIONS[DEFAULT_LANG]);
  }
}
